import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";
const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="pbo-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">
            Your Strategic Partner for Project-Based Success
          </h4>
          <p className="contact_investers_para">
            At Soori Corporation, we don’t just offer outsourcing; we provide a
            collaborative approach that transforms your projects into successes.
            Leveraging expert teams and industry insights, we deliver tailored
            solutions that drive efficiency and meet your unique business goals.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Elevate Your Projects Today
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
